import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { CHANNELS_MAX_FORM_LIMIT } from '../lib/constants';

export const useFormSchemaUpdate = () => {
  const { t } = useTranslation('translation');

  const requiredMessage = t('common.formErrors.required');
  const maxNameMessage = t('common.formErrors.stringMaxLen', {
    max: CHANNELS_MAX_FORM_LIMIT.name,
  });
  const maxDescriptionMessage = t('common.formErrors.stringMaxLen', {
    max: CHANNELS_MAX_FORM_LIMIT.description,
  });
  const maxStartMessageMessage = t('common.formErrors.stringMaxLen', {
    max: CHANNELS_MAX_FORM_LIMIT.start_message,
  });

  const baseFields = z
    .object({
      name: z
        .string()
        .trim()
        .min(1, requiredMessage)
        .max(CHANNELS_MAX_FORM_LIMIT.name, maxNameMessage),
      isActive: z.boolean(),
      agentId: z.coerce
        .number({ required_error: requiredMessage })
        .int(t('common.formErrors.integer'))
        .min(1, t('common.formErrors.minNumber', { min: 1 })),
      description: z
        .string()
        .trim()
        .max(CHANNELS_MAX_FORM_LIMIT.description, maxDescriptionMessage)
        .optional(),
      token: z.string().trim().optional(),
      host: z.string().trim().optional(),
      presetId: z.number().int().min(1).nullable().optional(),
      clientId: z.string().trim().optional(),
      clientSecret: z.string().trim().optional(),
      startMessage: z
        .string()
        .trim()
        .max(CHANNELS_MAX_FORM_LIMIT.start_message, maxStartMessageMessage)
        .optional(),
    })
    .passthrough();

  return {
    baseFields,
  };
};
